import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ReloadOutlined, CloseOutlined } from '@ant-design/icons'

import SButton from '../common/SButton'
import useVersionCheck from './useVersionCheck'
import { isPreviewPage, reloadApp } from './version.utils'

import './index.css'

/**
 * Non-blocking notice shown above the navbar as soon as a newer build is detected on the server.
 * Rendered in normal flow (sticky) so it pushes the page down instead of covering the navbar.
 */
export default function NewVersionBanner() {
    const { t } = useTranslation()
    const location = useLocation()
    const newVersionAvailable = useVersionCheck()
    const [dismissed, setDismissed] = useState(false)

    if (!newVersionAvailable || dismissed || isPreviewPage(location.pathname)) return null

    return (
        <div className="new-version-banner" role="status">
            <span className="new-version-banner-text">{t('A new version of Scoring.fit is available.')}</span>
            <SButton
                value={t('Reload')}
                size="small"
                Icon={ReloadOutlined}
                iconLocation="left"
                onClick={reloadApp}
                className="new-version-banner-reload"
            />
            <button
                type="button"
                className="new-version-banner-close"
                aria-label={t('Later')}
                title={t('Later')}
                onClick={() => setDismissed(true)}
            >
                <CloseOutlined />
            </button>
        </div>
    )
}
